import React from "react";
import "./CreateUserComponent.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import CustomizedButton from "@components/ButtonConfirm/ButtonConfirm";
import { useGetRolesByCompanyQuery } from "store/role/role.api";
import {
  useCreateUserMutation,
  useUpdateUserMutation,
} from "store/user/userApi";

const CreateUserComponent = ({ onClose, user }) => {
  const { t } = useTranslation();
  const currentUser = useSelector((state) => state.auth.user);
  const companyId = currentUser?.companyId?._id;

  const { data: roles, isLoading } = useGetRolesByCompanyQuery(companyId, {
    skip: !companyId,
  });

  console.log("user", user);
  const [createUser, { isLoading: isCreating }] = useCreateUserMutation();
  const [updateUser, { isLoading: isUpdating }] = useUpdateUserMutation();

  const { register, handleSubmit } = useForm({
    values: user
      ? {
          name: user.name,
          email: user.email,

          roleId: user?.roleId?._id || "",
        }
      : {
          name: "",
          email: "",
          companyId: companyId,
          roleId: "",
        },
  });

  const onSubmit = async (data) => {
    try {
      const userData = { ...data, companyId };
      await createUser(userData).unwrap();
      toast.success(t("users.form.create_success"));
      onClose();
    } catch {
      toast.error(t("users.form.create_error"));
    }
  };

  const onUpdate = async (data) => {
    try {
      await updateUser({ userId: user._id, data }).unwrap();
      toast.success(t("users.form.update_success"));
      onClose();
    } catch {
      toast.error(t("users.form.update_error"));
    }
  };
  console.log(roles?.data);
  return (
    <>
      <div className="row-container1 flex-column">
        {/* Nom */}
        <div className="input-container">
          <div className="input-title">{t("users.form.name")}</div>
          <input
            {...register("name", { required: "Le nom est requis" })}
            className="input-content1"
            placeholder={t("users.form.name_placeholder")}
          />
        </div>

        {/* Email */}
        <div className="input-container">
          <div className="input-title">{t("users.form.email")}</div>
          <input
            {...register("email", {
              required: "L'email est requis",
              pattern: {
                value: /^\S+@\S+$/i,
                message: "Adresse email invalide",
              },
            })}
            className="input-content1"
            type="email"
            placeholder={t("users.form.email_placeholder")}
          />
        </div>

        {/* Role */}
        <div className="input-container">
          <div className="input-title">{t("users.form.role")}</div>
          <select
            {...register("roleId", { required: "Le rôle est requis" })}
            className="input-content1">
            <option value="">{t("users.form.select_role")}</option>
            {isLoading ? (
              <option disabled>Loading roles...</option>
            ) : (
              roles?.data?.map((role) => (
                <option key={role._id} value={role._id}>
                  {role.name}
                </option>
              ))
            )}
          </select>
        </div>
      </div>

      {/* Bouton */}
      <CustomizedButton
        creatingText={t(user ? "users.form.updating" : "users.form.creating")}
        finalizeText={t(user ? "users.form.update" : "users.form.submit")}
        handleCreate={() => {
          if (user) handleSubmit(onUpdate)();
          else handleSubmit(onSubmit)();
        }}
        isCreating={isCreating || isUpdating}
        className="btn w-100"
      />
    </>
  );
};

export default CreateUserComponent;
